(function () {
  const BIRTHDAY_SELECTOR = 'input[type="date"][placeholder="生年月日"]';

  let initialBirthday = null;
  let lockedBirthday = null;

  function getRoot() {
    const hub = document.querySelector('accounts-hub');

    if (!hub || !hub.shadowRoot) {
      return null;
    }

    return hub.shadowRoot;
  }

  function getBirthdayInput(root) {
    return root.querySelector(BIRTHDAY_SELECTOR);
  }

  function lockBirthday(input, value) {
    if (!input || !value) return;

    lockedBirthday = value;

    input.value = value;
    input.readOnly = true;
    input.setAttribute('readonly', '');
    input.setAttribute('data-birthday-locked', 'true');
  }

  function initializeBirthday() {
    const root = getRoot();
    if (!root) return false;

    const input = getBirthdayInput(root);
    if (!input) return false;

    /*
     * 初回だけ判定
     *
     * C:Hubロード時点ですでに値がある
     * → 既存登録済みなのでロック
     *
     * 空
     * → 初回登録可能
     */
    if (initialBirthday === null) {
      initialBirthday = input.value || '';

      if (initialBirthday) {
        lockBirthday(input, initialBirthday);
      }
    }

    /*
     * C:HubがDOMを再描画した場合も
     * ロック状態を復元
     */
    if (lockedBirthday) {
      lockBirthday(input, lockedBirthday);
    }

    return true;
  }

  function watchSave() {
    const root = getRoot();
    if (!root) return;

    root.addEventListener('submit', function (event) {
      const form = event.target;

      if (!form || form.tagName !== 'FORM') return;

      const input = form.querySelector(BIRTHDAY_SELECTOR);

      if (!input) return;

      /*
       * すでに登録済みなら値を固定
       */
      if (lockedBirthday) {
        input.value = lockedBirthday;
        return;
      }

      /*
       * 未登録 → 初回入力
       */
      const newBirthday = input.value;

      if (!newBirthday) return;

      /*
       * C:Hubの保存処理を邪魔しないよう、
       * submit完了後にロックする
       */
      setTimeout(function () {
        const currentRoot = getRoot();
        if (!currentRoot) return;

        const currentInput = getBirthdayInput(currentRoot);
        if (!currentInput) return;

        lockBirthday(currentInput, newBirthday);
      }, 1000);
    });
  }

  function init() {
    const waitForHub = setInterval(function () {
      const root = getRoot();

      if (!root) return;

      const input = getBirthdayInput(root);

      /*
       * C:Hubが値をセットする前に判定しない
       */
      if (!input) return;

      clearInterval(waitForHub);

      /*
       * C:Hubによるmetafield値セットを少し待つ
       */
      setTimeout(function () {
        initializeBirthday();
        watchSave();

        /*
         * Profile切替・再描画対策
         */
        const observer = new MutationObserver(function () {
          initializeBirthday();
        });

        observer.observe(root, {
          childList: true,
          subtree: true
        });

      }, 500);

    }, 300);

    setTimeout(function () {
      clearInterval(waitForHub);
    }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();